export default __webpack_public_path__ + "static/media/project-9.ac3bde76.png";